import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material'
import { FormBuilder, FormControl, FormArray, Validators, FormGroup } from '@angular/forms';
import { StaffService } from "../../services/staff/staff.service";
import { EncryptDecryptService } from '../../services/encrypt-decrypt.service';
import { MpService } from 'src/app/services/staff/mp.service';
import { DeleteConfirmModalComponent } from '../../commons/delete-confirm-modal/delete-confirm-modal.component';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { PolicyService } from '../../services/policy.service'
import { Observable } from 'rxjs';
import * as _ from 'lodash';
declare var $;


export interface Instructor {
  _id: string;
  name: string;
  dateOfJoining: Date;
  email: string;
  password: string;
  qualifications: []
};

@Component({
  selector: 'app-add-staff-modal',
  templateUrl: './add-staff-modal.component.html',
  styleUrls: ['./add-staff-modal.component.scss']
})
export class AddStaffModalComponent implements OnInit {
  loading: Boolean = false;
  passwordMismatch: boolean;
  error: string;
  errorFromserver: any;
  inputElement: ElementRef;
  module: any;
  isEdit
  newFiles = []
  userFiles = []
  addUserForm
  systemDate
  userRoleList = [
    { key: "Medical Practitioner", value: "mp", },
    { key: "Trainer", value: "trainer", },
    { key: "IQA", value: "IQA", },
    { key: "Operative", value: "operative" }
  ]
  userFields = [
    // { id: '0', label: 'Primary/sub sponsor', display: 'Primary/sub sponsor', status: 'isPrimary', checked: false, isDisplay: true },
    { id: '1', label: 'Does person drive?', display: 'Does person drive?', status: 'isDrive', checked: false, isDisplay: true },
    { id: '2', label: 'Has own vehicle?', display: 'Has own vehicle?', status: 'isVehicle', checked: false, isDisplay: false },
    { id: '3', label: 'Assigned company vehicle?', display: 'Assigned company vehicle?', status: 'isAssigned', checked: false, isDisplay: false },
    { id: '4', label: 'Is this person in learning support?', display: 'Is this person in learning support?', status: 'isLearning', checked: false, isDisplay: true },
    { id: '5', label: 'Have any motoring convictions?', display: 'Have any motoring convictions?', status: 'isMotoring', checked: false, isDisplay: true },
  ]
  select = [
    { key: "Primary", value: "primary", },
    { key: "Sub-sponsor", value: "subSponsor", },
  ]
  licenseCategories = [
    { key: 'A', value: 'A', type: 'Motorbikes' },
    { key: 'AM', value: 'AM', type: '2 or 3 wheeled motors' },
    { key: 'B', value: 'B', type: 'Cars' },
    { key: 'B auto', value: 'Bauto', type: 'Automatic cars' },
    { key: 'B+E', value: 'B+E', type: 'Cat B + trailer' },
    { key: 'B1', value: 'B1', type: 'Light vehicles' },
    { key: 'C', value: 'C', type: 'Large lorries' },
    { key: 'C+E', value: 'C+E', type: 'Cat C + trailer' },
    { key: 'C1', value: 'C1', type: 'Lorries' },
    { key: 'C1+E', value: 'C1+E', type: 'Cat C1 + trailer' },
    { key: 'D', value: 'D', type: 'Bus' },
    { key: 'D+E', value: 'D+E', type: 'Cat D + trailer' },
    { key: 'D1', value: 'D1', type: 'Minibus' },
    { key: 'D1+E', value: 'D1+E', type: 'Cat D1 + trailer' },
    { key: 'F', value: 'F', type: 'Tractor' },
    { key: 'G', value: 'G', type: 'Road roller' },
    { key: 'H', value: 'H', type: 'Tracked vehicles' },
    { key: 'K', value: 'K', type: 'Pedestrian vehicles' },
    { key: 'Q', value: 'Q', type: '2 wheeled motors' },
  ]
  currentUser
  isConviction = false
  isUserRole = false
  dateisValid: boolean = false;
  isSubmit: boolean;
  passwordNotMatch: boolean = false;
  passwords = ''
  confirmPassword = ''
  @ViewChild('clickMenuTrigger', { static: false })
  private readonly clickMenuTrigger: MatMenuTrigger;

  ngOnInit() {
    console.log("data to be get", this.data);
    this.systemDate = this.data.date


    this.currentUser = JSON.parse(localStorage.getItem('currentUser'))


    this.module = JSON.parse(localStorage.getItem('module'))

    $("#password").click(function () {
      console.log("hoverd")
      $("#password").toggleClass("fa-eye fa-eye-slash");
    });

    $("#capassword").click(function () {
      $("#capassword").toggleClass("fa-eye fa-eye-slash");
      // $("#txtConfirmPassword").keyup(checkPasswordMatch);
    });

    $("input").removeClass('cdk-text-field-autofill-monitored mat-form-field-autofill-control')
    this.isSubmit = false;
    this.createForm()

  }

  show: boolean;
  pwd: boolean;

  maxDate = new Date();

  show1: boolean;
  pwd1: boolean;

  constructor(
    public _EncryptDecryptService: EncryptDecryptService,
    public _mpService: MpService,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _staffService: StaffService,
    public dialog: MatDialog,
    public formBuilder: FormBuilder,
    public _policyService: PolicyService
  ) {
    // NO DEFINITION
  }



  // FORM CONTROLL


  createForm() {
    this.addUserForm = this.formBuilder.group({
      name: new FormControl('', Validators.required),
      email: new FormControl('', Validators.email),
      password: new FormControl('', Validators.compose([
        Validators.required,
        this._policyService.patternValidator(/\d/, { hasNumber: true }),
        this._policyService.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        Validators.minLength(8)
      ])),
      confirmPassword: new FormControl('', Validators.required),
      dateOfJoining: new FormControl('', Validators.required),
      role: new FormControl(''),
      sentinelNumber: new FormControl(''),
      insuranceNumber: new FormControl(''),
      points: new FormControl(''),
      convictionList: this.formBuilder.array(this.multipleConvictions()),
      license: new FormControl(''),
      selects: new FormControl(''),
      userFields: new FormControl('')
    }, {
      validator: this._policyService.passwordMatchValidator
    })
  }



  get multipleConvictionGroup() { return <FormArray>this.addUserForm.get('convictionList') }

  multipleConvictions(data?): Array<any> {


    if (data && data.length) {

      const convictionList = []
      _.forEach(data, async (visit) => {
        await convictionList.push(new FormGroup({
          conviction: new FormControl(''),
        }))
      })
      return convictionList;
    } else {
      return [this.formBuilder.group({
        conviction: new FormControl(''),
      })
      ]
    }

  }

  onKeyPress(x) {
    x.preventDefault();
    this.clickMenuTrigger.openMenu();
    console.log("value of password", this.passwords);
  }
  closeModel() {
    this.clickMenuTrigger.closeMenu();
  }


  onKeyUp(x) {
    this.confirmPassword = x.target.value;

    console.log("value of confirm password", this.addUserForm.value.password, this.confirmPassword);

    if (this.addUserForm && this.addUserForm.value && this.addUserForm.value.password != this.confirmPassword) {
      this.passwordNotMatch = true
      this.addUserForm.get('confirmPassword').markAsTouched();
    } else if (this.addUserForm.value.password == this.confirmPassword) {
      this.passwordNotMatch = false
    }
    console.log("this.passwordNotMatch", this.passwordNotMatch);
  }

  addFileModal() {
    let obj = {
      // isIncident: true
      isStaff: true
    }

    let addedCourse = this.openDialog(NewFileModalComponent, obj).subscribe((fileQueue) => {
      console.log("The queue recieved is", fileQueue);
      if (fileQueue == undefined || fileQueue.length == 0) return;

      _.forEach(fileQueue, (file) => {
        if (this.isEdit) {
          this.newFiles.push(file)
        } else {
          this.userFiles.push(file);
        }
      })

      console.log("file upload success fully", fileQueue)
    }, err => {
      console.log("some error occure at staff file upload!!!!!!!", err)
      // return this.openSnackBar("Something went wrong!", "Ok");
    });
  }

  deleteFile(event) {
    console.log("event if file removed", event, this.isEdit);
    this.userFiles.splice(event, 1)
    console.log("after file removd", this.userFiles);

  }
  deleteNewFile(event) {
    this.newFiles.splice(event, 1)
  }




  addConviction() {
    const control = <FormArray>this.addUserForm.controls.convictionList

    control.push(this.formBuilder.group({
      conviction: new FormControl(''),
    }))
  }



  deleteConviction(data, i) {
    console.log("what is in client", data);
    console.log("index value============", i);
    const control = <FormArray>this.addUserForm.controls.convictionList
    control.removeAt(i)
  }

  // UTILITY

  onChangeEvent(value, formControl) {
    console.log("value of date", value);
    console.log('formControl', formControl);
    this.dateisValid = true
    this.isSubmit = false
    if (formControl == 'dateOfJoining') {
      this.addUserForm.patchValue({ dateOfJoining: value })
    }
  }

  checkUserRole() {
    let userRole = this.addUserForm.get('role').value
    if (userRole.includes('trainer') || userRole.includes('operative')) return true
    else return false
  }

  userRoleSelection(event) {
    console.log("what is the event", event);
    let userRole = this.addUserForm.get('role').value
    if (userRole.includes('trainer') || userRole.includes('operative')) this.isUserRole = true
    else this.isUserRole = false
  }


  selectedStatus(event, data) {
    console.log("what is the event", event);
    console.log("data to be send", data);
    if (data == 'isDrive' && event) {
      this.userFields[1].isDisplay = true
      this.userFields[2].isDisplay = true
    }
    if (data == 'isDrive' && !event) {
      this.userFields[1].isDisplay = false
      this.userFields[2].isDisplay = false
    }

    if (data == 'isMotoring' && event) {
      this.isConviction = true
    } else if (data == 'isMotoring' && !event) {
      this.isConviction = false
    }



  }




  validate(data) {
    console.log("Validating ", data);
    if (!data.name) return { valid: false, field: "Name" };
    if (!data.email) return { valid: false, field: "Email" };
    if (!data.password) return { valid: false, field: "Password" };
    if (!data.confirmPassword) return { valid: false, field: "Confirm Password" };
    if (!data.dateOfJoining) return { valid: false, field: "Date of Joining" };
    if (!data.role) return { valid: false, field: "User Role" }
    if (data.password !== data.confirmPassword) {
      this.passwordMismatch = true;
      return false
      // return { valid: false, field: "Password Missmatch" };
    }
    this.passwordMismatch = false;
    return true
    // return { valid: true, field: "Password Missmatch" };
  }

  dateSelected(event) {
    console.log("event---->", event);
    this.data.dateOfJoining = event
  }


  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data, width: '500px', height: '600px' });
    return dialogRef.afterClosed();
  }
  password() {
    this.show = !this.show;
    this.pwd = !this.pwd;
  }

  cpassword() {
    this.show1 = !this.show1;
    this.pwd1 = !this.pwd1
  }

  onNoClick(): void {
    this.dialogRef.close();
  }




  // API CALL


  doSubmit() {
    this.error = ""
    this.errorFromserver = ""
    console.log("value of form submit", this.addUserForm.value);
    if (this.addUserForm.valid && !this.passwordNotMatch) {
      this.loading = true;
      let newPassword = this._EncryptDecryptService.encrypt(this.addUserForm.get('password').value)

      this.addUserForm.value.password = newPassword;
      this.addUserForm.value.confirmPassword = newPassword;
      // this.addUserForm.controls.userFiles.setValue(this.userFiles);
      console.log("this user files upload ===>", this.addUserForm)
      // this.userFiles;
      this._staffService.addInstructor(this.addUserForm.value, this.userFields, this.currentUser, this.userFiles).subscribe(data => {
        this.data = data;
        this.loading = false;
        this.dialogRef.close(data);


      }, err => {
        this.addUserForm.controls.password.setValue(this.addUserForm.get('confirmPassword').value);

        console.log("error while add user", err);
        this.loading = false;
        if (err.exits) {
          let data = {
            msg: err.msg,
            isDelete: true
          }
          this.openDialog(DeleteConfirmModalComponent, data).subscribe(confirm => {
            console.log("confirm modal details", confirm);
            if (confirm == 'yes') {
              this.loading = true
              let obj = {
                isRetrive: true,
                userData: this.addUserForm.value
              }
              this._staffService.retriveInstructor(obj).subscribe((data) => {
                console.log("new user added data", data);
                this.loading = false
                this.dialogRef.close(data)
              }, error => {
                console.log("error while add new user", error);
                this.loading = false
              })
            } else {
              this.loading = true
              let obj = {
                isRetrive: false,
                userData: this.addUserForm.value
              }
              this._staffService.retriveInstructor(obj).subscribe((data) => {
                console.log("new user added data", data);
                this.loading = false
                this.dialogRef.close(data)
              }, error => {
                console.log("error while add new user", error);
                this.loading = false
              })
            }

          })
        } else {
          this.errorFromserver = err.msg
        }
      });
    } else {
      console.log("form is not validate");
      this.isSubmit = true
      this.addUserForm.markAllAsTouched();
      return
    }

    // // Do Submit

  }

}